module.exports = __webpack_public_path__ + "images/ShopNowImage_aa77b1f.svg";